/*
*  AGP events
*  Fichier gestion accès
*/

import $ from "jquery";

var Highcharts = require('highcharts');
require('highcharts/modules/exporting')(Highcharts);

export default class Access {

    constructor() {

    }

    // ready
    onReady() {
        if ($("input[name=page_access]").length > 0) {
            this.init();
        }

        $(document).on("click", "._open_fullscreen", function () {

            $("._user_detail").toggleClass("_full");
            if ($("._user_detail").hasClass("_full")) {
                $(this).find("span").html("Fermer");
            } else {
                $(this).find("span").html("Aggrandir");
            }

        });

        $(document).on("click", "._view_user_detail", function () {

            let _user = $(this).data("user");
            let _edition = $(this).data("edition");

            $.ajax({
                url: _URL + "/view-user-access",
                data: {
                    user_id: _user,
                    edition_id: _edition
                },
                type: "POST",
                context: document.body
            }).done(function (response) {

                // var get_response=js
                //
                // var data = response.access.zone.data;
                // var days = response.days;
                // var rows = [];

                $("._user_detail").show().html(response);

                $(".table_filter").bootstrapTable({
                    pagination: true,
                    locale: 'fr-FR'
                });

                //console.log(response);
                // _this_inside.find(".__show_access").html(response);
                // //_this.prev(".__show_access").show();
                // user.view_user_load = false;
                return false;
            });


        });

    }

    // init
    init() {

        if ($("#container-jours").length > 0) {
            this.chartJours();
        }

        if ($("#container-zones").length > 0) {
            this.chartZones();
        }

    };

    chartZones() {
        let _days = JSON.parse($("input[name=_days]").val());
        let _zones = JSON.parse($("input[name=passages_zones]").val());

        //console.log(_zones);

        const transformedObj = Object.entries(_zones).map(([key, value]) => ({
            name: key.replace(' ', ''),
            data: value
        }));

        //console.log(transformedObj);


        Highcharts.chart('container-zones', {
            chart: {
                type: 'area'
            },
            title: {
                text: ''
            },
            legend: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            xAxis: {
                categories: _days,
                labels: {
                    formatter: function () {
                        return this.value; // date format
                    }
                }
            },
            yAxis: {
                title: {
                    text: 'Passages'
                }
            },
            series: transformedObj
        });
    }

    chartJours() {

        let _days = JSON.parse($("input[name=_days]").val());
        let _passages_days = JSON.parse($("input[name=passages_day]").val());
        let _passages_days_valid = JSON.parse($("input[name=passages_day_valid]").val());


        Highcharts.chart('container-jours', {
            title: {
                text: ''
            },
            xAxis: {
                categories: _days,
                labels: {
                    formatter: function () {
                        return this.value; // date format
                    }
                }
            },
            yAxis: {
                title: {
                    text: 'Passages'
                }
            },
            legend: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            series: [{
                name: 'Passages',
                data: _passages_days
            }, {
                name: 'Passages autorisés',
                data: _passages_days_valid
            }]
        });
    }


}

/* Highcharts.chart('container-jours', {
            chart: {
                type: 'area'
            },
            title: {
                text: 'Accès par jours'
            },
            xAxis: {
                categories: _days,
                labels: {
                    formatter: function () {
                        return this.value; // date format
                    }
                }
            },
            yAxis: {
                title: {
                    text: 'Visits'
                }
            },
            series: [{
                name: 'Zone 1',
                data: [50, 60, 10]
            }, {
                name: 'Zone 2',
                data: [20, 30, 50]
            }, {
                name: 'Zone 3',
                data: [80, 70, 60]
            }, {
                name: 'Zone 4',
                data: [10, 20, 30]
            }, {
                name: 'Zone 5',
                data: [40, 50, 70]
            }]
        });
    }*/


